/** Internal navigation carries a click value, not evidence of when that click was first seen. */
export const FBCLID_PROVENANCE_PARAM = 'podo_fbclid_provenance'

/** Kept outside MARKETING_PARAM_KEYS: this is not attribution and must not create a new cookie. */
export function markCarriedFbclid(url: URL): URL {
  if (url.searchParams.get('fbclid')) {
    url.searchParams.set(FBCLID_PROVENANCE_PARAM, 'unknown')
  }
  return url
}
